/**
 * Détermine si un slot est piloté par un humain (sinon IA).
 * Les slots au-delà du tableau d’effectif sont traités comme IA.
 */
export function isSlotHumanPlayer(
  playerIndex: number,
  numParticipants: number,
  localRoster: readonly boolean[],
  multiIsHuman?: readonly boolean[] | null
): boolean {
  if (playerIndex < 0 || playerIndex >= numParticipants) return false;
  if (multiIsHuman != null) {
    if (playerIndex >= multiIsHuman.length) return false;
    return multiIsHuman[playerIndex] === true;
  }
  if (localRoster.length === 0) {
    return playerIndex === 0;
  }
  if (playerIndex >= localRoster.length) return false;
  return localRoster[playerIndex] === true;
}

/** Étend ou tronque le tableau humain/IA pour couvrir exactement tous les participants. */
export function padHumanRoster(roster: readonly boolean[], numParticipants: number): boolean[] {
  return Array.from({ length: numParticipants }, (_, i) => roster[i] === true);
}
